import { joiResolver } from "@hookform/resolvers/joi";
import {
  Button,
  Checkbox,
  Divider,
  FormControlLabel,
  Grid,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { get, size } from "lodash";
import { useSnackbar } from "notistack";
import React, { useCallback, useMemo } from "react";
import { useForm } from "react-hook-form";
import { getHelpData } from "../../data/selectors/Help/helpForm.selector";
import {
  helpEntrySchema,
  useHelpForm,
} from "../../data/talons/Help/useHelpForm";
import { color } from "../../utils/constant";
import { useSelector } from "react-redux";
/*
 * Render Real - Estate Inquiry Form screen
 *
 *
 */

export default function HelpForm(props) {
  const { enqueueSnackbar } = useSnackbar();
  // const { editItem, editId } = props;
  const editItem = useSelector(getHelpData);

  const {
    loader,
    loading,
    status,
    helpEntrySchema,
    handleStatusComboChange,
    HelpEntry,
    helpUpdate,
  } = useHelpForm({
    existingStatus: get(editItem, "status", 0),
  });

  const defaultValues = useMemo(() => ({
    title: get(editItem, "title", ""),
    subTitle: get(editItem, "sub_title", ""),
    detail: get(editItem, "detail", ""),
  }));
  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
    control,
  } = useForm({
    resolver: joiResolver(helpEntrySchema),
    defaultValues,
  });

  // const onlyNumbers = (e) => {
  //   e.target.value = e.target.value.replace(/[^0-9]/g, "");

  //   if (e.target.value.toString().length === 0) return;
  //   return (e.target.value = Math.max(0, parseInt(e.target.value))
  //     .toString()
  //     .slice(0, 10));
  // };

  const onUserSubmit = useCallback(async () => {
    try {
      const res =
        get(editItem, "id", null) === null
          ? await HelpEntry({
              ...getValues(),
            })
          : await helpUpdate({
              ...getValues(),
              id: get(editItem, "id", null),
            });
      if (res === true) {
        props.postSubmit();
      } else {
        enqueueSnackbar("Problem While Saving Help Data", {
          variant: "error",
        });
      }
    } catch (err) {
      console.log("errr", err);
    }
  }, [HelpEntry]);

  const onlyCharacters = (e) => {
    e.target.value = e.target.value.replace(/[^a-zA-Z ]*$/, "");

    return e.target.value;
  };

  return (
    <React.Fragment>
      <Typography variant="h5" gutterBottom>
        Help Form
      </Typography>
      <Divider sx={{ mb: 3 }} />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={12}>
          <TextField
            required
            id="title"
            name="title"
            label="Title"
            onInput={(e) => onlyCharacters(e)}
            fullWidth={true}
            variant="outlined"
            size="small"
            inputProps={{
             // maxLength: 50,
            }}
            {...register("title")}
            autoComplete="false"
            error={size(errors?.title?.message) > 0 ? true : false}
            helperText={
              size(errors?.title?.message) > 0 ? errors?.title?.message : ""
            }
          />
        </Grid>
        <Grid item xs={12} sm={6} md={12}>
          <TextField
            required
            id="subTitle"
            name="subTitle"
            label="Sub Title"
            // onInput={(e) => onlyCharacters(e)}
            fullWidth={true}
            variant="outlined"
            size="small"
            inputProps={{
             // maxLength: 50,
            }}
            {...register("subTitle")}
            autoComplete="false"
            error={size(errors?.subTitle?.message) > 0 ? true : false}
            helperText={
              size(errors?.subTitle?.message) > 0
                ? errors?.subTitle?.message
                : ""
            }
          />
        </Grid>
        <Grid item xs={12} sm={6} md={12}>
          <TextField
            required
            id="detail"
            name="detail"
            label="Detail"
            // onInput={(e) => onlyCharacters(e)}
            fullWidth={true}
            variant="outlined"
            size="small"
            multiline
            minRows={3}
            inputProps={{
             // maxLength: 100,
            }}
            {...register("detail")}
            autoComplete="false"
            error={size(errors?.detail?.message) > 0 ? true : false}
            helperText={
              size(errors?.detail?.message) > 0 ? errors?.detail?.message : ""
            }
          />
        </Grid>

        <Grid item xs={3} sm={3}>
          <Typography>
            <FormControlLabel
              sx={{ mt: -1 }}
              control={
                <Checkbox
                  sx={{
                    "&.Mui-checked": {
                      color: color.button,
                    },
                  }}
                  id="is_labour"
                  checked={status}
                  onChange={handleStatusComboChange}
                />
              }
              label="Active"
            />
          </Typography>
        </Grid>
        <Grid container direction="row">
          <Grid item xs={12} sm={12}>
            <Stack direction="row" justifyContent="end">
              <Button
                variant="contained"
                sx={{
                  height: 40,
                  borderRadius: 3,
                  m: 1,
                  backgroundColor: color.button,
                  "&:hover": {
                    backgroundColor: color.button,
                  },
                }}
                type="submit"
                onClick={(e) => {
                  e.preventDefault();
                  handleSubmit(onUserSubmit)();
                }}
              >
                Save
              </Button>
              <Button
                sx={{
                  height: 40,
                  borderRadius: 3,
                  m: 1,
                  borderColor: color.button,
                  color: color.button,
                  "&:hover": {
                    color: color.button,
                  },
                }}
                variant="outlined"
                onClick={(e) => {
                  e.preventDefault();
                  props.postSubmit();
                }}
              >
                Cancel
              </Button>
            </Stack>
          </Grid>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
